import styled from "styled-components";

export const PoHistoryMobileWrapper = styled.div`
header{
  display: flex;
  flex-direction: column;
  grid-row-gap: 10px;
  margin-bottom: 16px;
}
section{
    display: flex;
    flex-direction: column;
    grid-row-gap: 12px;
    height: calc(100vh - 265px);
    overflow: auto;
}
`;
export const ModalWrapper = styled.div`
.delete-modal-wrapper{
display:flex;
flex-direction:column;
align-items: center;
justify-content:space-between;
}`